// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2561C","largestCol":"styles_largestCol__1MYCq","smallestCol":"styles_smallestCol__2Q-PE"};